import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

type NativeListingsSkeletonProps = {
  count?: number;
  className?: string;
};

/** Placeholder cards while listings load on native all-listings / campaign pages. */
export const NativeListingsSkeleton = ({
  count = 6,
  className,
}: NativeListingsSkeletonProps) => (
  <div className={cn("grid gap-3 mt-2", className)}>
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="flex gap-3 rounded-lg border border-border/60 bg-card p-2 min-h-[7.5rem]"
      >
        <Skeleton className="h-[5.5rem] w-[7.5rem] shrink-0 rounded-md" />
        <div className="flex flex-1 flex-col gap-2 py-0.5 min-w-0">
          <Skeleton className="h-4 w-[85%]" />
          <Skeleton className="h-3 w-[55%]" />
          <div className="grid grid-cols-2 gap-2 mt-auto">
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-[70%]" />
            <Skeleton className="h-3 w-[60%]" />
          </div>
          <Skeleton className="h-4 w-24 ml-auto" />
        </div>
      </div>
    ))}
  </div>
);
